import AbstractRequestTask from "../AbstractRequestTask";
import getAppConfig from "../../../config/appConfig";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class MusicTask extends AbstractRequestTask {
  constructor(service = "", user, params, headers) {
    super();
    this._config = getAppConfig();
    this._service = service;
    this._user = user;
    this.method = params.method;

    if(headers && headers.cm_access_token) {
      delete headers.cm_access_token;
    }

    this._params = {
      ...params,
      token: user.token,
      userId: user.id,
      deviceId: user.deviceId,
      type: user.type,
      cm_access_token: user.cm_access_token
    };
    this._headers = headers || {};
  }

  getMethod() {
    if (this.method) return this.method;
    return "GET";
  }

  getEncType() {
    if (this.getMethod() === "POST") return "multipart/form-data";

    return "application/x-www-form-urlencoded";
  }

  isValid(data) {
    if (
      data.errors &&
      !data.ribbons &&
      !data.albumDetail &&
      !data.playlistDetail
    ) {
      return false;
    }
    return true;
  }

  getUrl() {
    return `${this._config.end_point_music}/${this._service}`;
  }

  getParams() {
    const params = this._params;
    delete params.method;
    params.version = '1.0.0';

    return { ...this._params };
  }

  getHeaders() {
    const headers = {
      ...this._headers,
      "Access-Control-Allow-Origin": "*"
    };
    return headers;
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
		return ENABLE_MODAL_RETRIES;
	}
}

export default MusicTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/music/MusicTask.js